/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc
 */
import * as References from './ApplicationGovernanceAppAuthRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getApplicationGovernance
 */
export const GET_APPLICATION_GOVERNANCE_QUERY_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getApplicationGovernance';
export const GET_APPLICATION_GOVERNANCE_QUERY: RegisteredQuery<
  'result',
  References.GetApplicationGovernanceRequestType,
  References.GetApplicationGovernanceResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APPLICATION_GOVERNANCE_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(
    request: References.GetApplicationGovernanceRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetApplicationGovernanceResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getApplicationGovernanceRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#enableApplicationInstallable
 */
export const ENABLE_APPLICATION_INSTALLABLE_MUTATION_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_enableApplicationInstallable';
export const ENABLE_APPLICATION_INSTALLABLE_MUTATION: RegisteredQuery<
  'result',
  References.EnableApplicationInstallableRequestType,
  References.EnableApplicationInstallableResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: ENABLE_APPLICATION_INSTALLABLE_MUTATION_FIELD_NAME,
  args: ['appId'],
  fetcher(
    request: References.EnableApplicationInstallableRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.EnableApplicationInstallableResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.enableApplicationInstallableRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getApprovedApplicationPaginated
 */
export const GET_APPROVED_APPLICATION_PAGINATED_QUERY_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getApprovedApplicationPaginated';
export const GET_APPROVED_APPLICATION_PAGINATED_QUERY: RegisteredQuery<
  'result',
  References.GetApprovedApplicationPaginatedRequestType,
  References.GetApprovedApplicationPaginatedResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APPROVED_APPLICATION_PAGINATED_QUERY_FIELD_NAME,
  args: ['offset', 'pageLength'],
  fetcher(
    request: References.GetApprovedApplicationPaginatedRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetApprovedApplicationPaginatedResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getApprovedApplicationPaginatedRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#revokeApproval
 */
export const REVOKE_APPROVAL_MUTATION_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_revokeApproval';
export const REVOKE_APPROVAL_MUTATION: RegisteredQuery<
  'result',
  References.RevokeApprovalRequestType,
  References.RevokeApprovalResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: REVOKE_APPROVAL_MUTATION_FIELD_NAME,
  args: ['appId'],
  fetcher(
    request: References.RevokeApprovalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.RevokeApprovalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.revokeApprovalRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getAppGovernancePermissions
 */
export const GET_APP_GOVERNANCE_PERMISSIONS_QUERY_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getAppGovernancePermissions';
export const GET_APP_GOVERNANCE_PERMISSIONS_QUERY: RegisteredQuery<
  'result',
  References.GetAppGovernancePermissionsRequestType,
  References.GetAppGovernancePermissionsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APP_GOVERNANCE_PERMISSIONS_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(
    request: References.GetAppGovernancePermissionsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAppGovernancePermissionsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAppGovernancePermissionsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#approveAppGovernancePermissions
 */
export const APPROVE_APP_GOVERNANCE_PERMISSIONS_MUTATION_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_approveAppGovernancePermissions';
export const APPROVE_APP_GOVERNANCE_PERMISSIONS_MUTATION: RegisteredQuery<
  'result',
  References.ApproveAppGovernancePermissionsRequestType,
  References.ApproveAppGovernancePermissionsResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: APPROVE_APP_GOVERNANCE_PERMISSIONS_MUTATION_FIELD_NAME,
  args: [
    'appId',
    'installPermissionAccessState',
    'optionalAppPermissions',
    'conditionallyRequiredAppPermissions',
    'entityTypeAndIds',
  ],
  fetcher(
    request: References.ApproveAppGovernancePermissionsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ApproveAppGovernancePermissionsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.approveAppGovernancePermissionsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#updateAllowedAppPermissions
 */
export const UPDATE_ALLOWED_APP_PERMISSIONS_MUTATION_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_updateAllowedAppPermissions';
export const UPDATE_ALLOWED_APP_PERMISSIONS_MUTATION: RegisteredQuery<
  'result',
  References.UpdateAllowedAppPermissionsRequestType,
  References.UpdateAllowedAppPermissionsResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_ALLOWED_APP_PERMISSIONS_MUTATION_FIELD_NAME,
  args: [
    'appId',
    'conditionallyRequiredAppPermissions',
    'optionalAppPermissions',
  ],
  fetcher(
    request: References.UpdateAllowedAppPermissionsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateAllowedAppPermissionsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateAllowedAppPermissionsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#updateAllowedEntityTypeAndIds
 */
export const UPDATE_ALLOWED_ENTITY_TYPE_AND_IDS_MUTATION_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_updateAllowedEntityTypeAndIds';
export const UPDATE_ALLOWED_ENTITY_TYPE_AND_IDS_MUTATION: RegisteredQuery<
  'result',
  References.UpdateAllowedEntityTypeAndIdsRequestType,
  References.UpdateAllowedEntityTypeAndIdsResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_ALLOWED_ENTITY_TYPE_AND_IDS_MUTATION_FIELD_NAME,
  args: ['appId', 'installPermissionAccessState', 'entityTypeAndIds'],
  fetcher(
    request: References.UpdateAllowedEntityTypeAndIdsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateAllowedEntityTypeAndIdsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateAllowedEntityTypeAndIdsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getApprovableAppsWithStatus
 */
export const GET_APPROVABLE_APPS_WITH_STATUS_QUERY_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getApprovableAppsWithStatus';
export const GET_APPROVABLE_APPS_WITH_STATUS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetApprovableAppsWithStatusResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APPROVABLE_APPS_WITH_STATUS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetApprovableAppsWithStatusResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getApprovableAppsWithStatusRpc,
      { timeout: ctx.timeout, request: {} }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#removeAppPermissionsFromInstalls
 */
export const REMOVE_APP_PERMISSIONS_FROM_INSTALLS_MUTATION_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_removeAppPermissionsFromInstalls';
export const REMOVE_APP_PERMISSIONS_FROM_INSTALLS_MUTATION: RegisteredQuery<
  'result',
  References.RemoveAppPermissionsFromInstallsRequestType,
  References.RemoveAppPermissionsFromInstallsResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: REMOVE_APP_PERMISSIONS_FROM_INSTALLS_MUTATION_FIELD_NAME,
  args: ['appId', 'appPermissionIds'],
  fetcher(
    request: References.RemoveAppPermissionsFromInstallsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.RemoveAppPermissionsFromInstallsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.removeAppPermissionsFromInstallsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getOrCreateConnectedAppObject
 */
export const GET_OR_CREATE_CONNECTED_APP_OBJECT_MUTATION_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getOrCreateConnectedAppObject';
export const GET_OR_CREATE_CONNECTED_APP_OBJECT_MUTATION: RegisteredQuery<
  'result',
  References.GetOrCreateConnectedAppObjectRequestType,
  References.GetOrCreateConnectedAppObjectResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: GET_OR_CREATE_CONNECTED_APP_OBJECT_MUTATION_FIELD_NAME,
  args: ['appId'],
  fetcher(
    request: References.GetOrCreateConnectedAppObjectRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetOrCreateConnectedAppObjectResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getOrCreateConnectedAppObjectRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getAppsGovernanceStatus
 */
export const GET_APPS_GOVERNANCE_STATUS_QUERY_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getAppsGovernanceStatus';
export const GET_APPS_GOVERNANCE_STATUS_QUERY: RegisteredQuery<
  'result',
  References.GetAppsGovernanceStatusRequestType,
  References.GetAppsGovernanceStatusResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APPS_GOVERNANCE_STATUS_QUERY_FIELD_NAME,
  args: ['appIds'],
  fetcher(
    request: References.GetAppsGovernanceStatusRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAppsGovernanceStatusResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAppsGovernanceStatusRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getApprovedApplicationsForUserPaged
 */
export const GET_APPROVED_APPLICATIONS_FOR_USER_PAGED_QUERY_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getApprovedApplicationsForUserPaged';
export const GET_APPROVED_APPLICATIONS_FOR_USER_PAGED_QUERY: RegisteredQuery<
  'result',
  References.GetApprovedApplicationsForUserPagedRequestType,
  References.GetApprovedApplicationsForUserPagedResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APPROVED_APPLICATIONS_FOR_USER_PAGED_QUERY_FIELD_NAME,
  args: ['offset', 'pageLength'],
  fetcher(
    request: References.GetApprovedApplicationsForUserPagedRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetApprovedApplicationsForUserPagedResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getApprovedApplicationsForUserPagedRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getListingIdsToExclude
 */
export const GET_LISTING_IDS_TO_EXCLUDE_QUERY_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getListingIdsToExclude';
export const GET_LISTING_IDS_TO_EXCLUDE_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetListingIdsToExcludeResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_LISTING_IDS_TO_EXCLUDE_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetListingIdsToExcludeResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getListingIdsToExcludeRpc,
      { timeout: ctx.timeout, request: {} }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getAppDataPermissionsStatus
 */
export const GET_APP_DATA_PERMISSIONS_STATUS_QUERY_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getAppDataPermissionsStatus';
export const GET_APP_DATA_PERMISSIONS_STATUS_QUERY: RegisteredQuery<
  'result',
  References.GetAppDataPermissionsStatusRequestType,
  References.GetAppDataPermissionsStatusResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APP_DATA_PERMISSIONS_STATUS_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(
    request: References.GetAppDataPermissionsStatusRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAppDataPermissionsStatusResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAppDataPermissionsStatusRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#checkAppInstallability
 */
export const CHECK_APP_INSTALLABILITY_QUERY_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_checkAppInstallability';
export const CHECK_APP_INSTALLABILITY_QUERY: RegisteredQuery<
  'result',
  References.CheckAppInstallabilityRequestType,
  References.CheckAppInstallabilityResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: CHECK_APP_INSTALLABILITY_QUERY_FIELD_NAME,
  args: [
    'appId',
    'conditionallyRequiredAppPermissionIds',
    'optionalAppPermissionIds',
  ],
  fetcher(
    request: References.CheckAppInstallabilityRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CheckAppInstallabilityResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.checkAppInstallabilityRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getAppEmaStatus
 */
export const GET_APP_EMA_STATUS_QUERY_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getAppEmaStatus';
export const GET_APP_EMA_STATUS_QUERY: RegisteredQuery<
  'result',
  References.GetAppEmaStatusRequestType,
  References.GetAppEmaStatusResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APP_EMA_STATUS_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(
    request: References.GetAppEmaStatusRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAppEmaStatusResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAppEmaStatusRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#updateAppEmaStatus
 */
export const UPDATE_APP_EMA_STATUS_MUTATION_FIELD_NAME =
  'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_updateAppEmaStatus';
export const UPDATE_APP_EMA_STATUS_MUTATION: RegisteredQuery<
  'result',
  References.UpdateAppEmaStatusRequestType,
  References.UpdateAppEmaStatusResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_APP_EMA_STATUS_MUTATION_FIELD_NAME,
  args: ['appId', 'emaOptedIn', 'trustedIssuerUrl'],
  fetcher(
    request: References.UpdateAppEmaStatusRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateAppEmaStatusResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateAppEmaStatusRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
